import { Transaction } from './types'

const typePriority = {
  INIT: 2,
  INTERVAL_INTEREST: 1,
  PAYMENT: 0,
  CLOSE: -1
}

export const sortTransactions = (
  transactions: Transaction[]
): Transaction[] => {
  return transactions.sort(
    (a, b) => {
      const daysDiff = a.createdOn.diff(b.createdOn, 'days')

      return daysDiff !== 0
        ? daysDiff
        : typePriority[b.type] - typePriority[a.type]
    }
  )
}

export default sortTransactions



// WEBPACK FOOTER //
// ./src/utils/transactions/sortTransactions.tsx